export default "__VITE_ASSET__DkW$XR2Q__"